import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PdfService } from '../../shared/services/pdf.service';
import { ModalController } from '@ionic/angular';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { DmcPackageService } from 'src/app/business-service/dmc-package/dmc-package.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { StatusUpdateService } from 'src/app/business-service/status-update/status-update.service';
import { ENTITY_NAMES, ORGANIZATION_TYPES, RECORD_STATUS_VALUES } from '../../shared/constants/api-constants';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { LeadsService } from 'src/app/business-service/leads/leads.service';

@Component({
  selector: 'app-dmc-packages-review',
  templateUrl: './dmc-packages-review.component.html',
  styleUrls: ['./dmc-packages-review.component.scss'],
})
export class DmcPackagesReviewComponent implements OnInit {

  @Input() packageId: any;
  leadId: any;
  organizationId: any;
  packageData: any;
  packageDataHtml: SafeHtml = "";

  packageDetails: any;

  showApproveBtn: boolean = false;

  viewOnly: boolean = false;

  orgType: any;

  ORGANIZATION_TYPES = ORGANIZATION_TYPES;

  constructor(
    private _pdfServie: PdfService,
    private _modalController: ModalController,
    private _modalService: ModalsService,
    private _dmcPackageService: DmcPackageService,
    private _sanitizer: DomSanitizer,
    private _responseNotificationService: ResponseNotificationService,
    private _statusUpdateService: StatusUpdateService,
    private _reloadService: ComponentReloadService,
    private _globalService: GlobalService,
    private _modalPopupService: ModalsService,
    private _leadService: LeadsService
  ) { }

  async ngOnInit() {
    this.orgType = localStorage.getItem('CType');    
    if (!this.organizationId) {
      this.organizationId = localStorage.getItem('CId')
    }
    await this.getPackageHtml();

    this.packageDetails = await this.getPackageDetails();
    if (this.packageDetails?.dmcPackages?.status !== RECORD_STATUS_VALUES.APPROVED) {
      this.showApproveBtn = true;
    }
  }

  async getPackageDetails(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this._dmcPackageService.getPackage(this.packageId, this.organizationId).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (error) => {
          console.error('Error fetching package:', error);
          this._responseNotificationService.showMessage("Failed to fetch package details, please try again", true);
          reject(error);
        }
      });
    })
  }
  async getPackageHtml(): Promise<any> {
    return new Promise<void>((resolve) => {
      this._dmcPackageService.getPackageTemplate(this.packageId, this.organizationId).subscribe({
        next: (data) => {
          this.packageData = data;
          this.packageDataHtml = this._sanitizer.bypassSecurityTrustHtml(this.packageData);
          resolve();
        },
        error: (error) => {
          console.error('Error fetching package:', error);
          this._responseNotificationService.showMessage("Failed to fetch template, please try again", true);
          this.closeModal();
          resolve();
        }
      });
    })
  }

  closeModal() {
    this._modalController.dismiss()
  }

  editPackage() {
    this.closeModal();
    this._modalService.openDmcPackageForm(this.packageId);
  }

  // Print html review template
  async printPackage(): Promise<void> {
    await this.createLeadForDmc();
    if (this.packageData) {
      this._pdfServie.generatePdf(this.packageData, true).subscribe(
        (blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `DMC_Package_${this.packageId}.pdf`;
        link.click();
        URL.revokeObjectURL(link.href);
      },
        (error) => {
          console.error('Error generating PDF:', error);
        }
      );
    }
  }

  async createLeadForDmc(): Promise<any>{
    return new Promise<any>((resolve, reject)=>{
      this._leadService.createDmcLead(this.packageId, this.organizationId).subscribe({
        next: (data)=>{
          resolve(data);
        }, error: (err)=>{
          reject(err);
        }
      })
    })
  }

  approvePackage() {
    this._statusUpdateService.updateStatusOfRecord(ENTITY_NAMES.DMC_PACKAGE, this.packageId, RECORD_STATUS_VALUES.APPROVED).subscribe((data) => {
      this._responseNotificationService.showMessage("DMC Package Approved!");
      this._reloadService.triggerDMCPackagesReload()
      this.showApproveBtn = false;
    })
  }

  async createQuote() {
    this._modalController.dismiss({
      createQuote: true
    });
  }

  async createQuoteForNewLead() {
    const recommendedItinerary = {
      recommendedItineraryId: this.packageId,
      recommendedItineraryType: ENTITY_NAMES.DMC_PACKAGE,
      recommendedOrganizationId: this.organizationId
    };
    this._globalService.setRecommendedItinerary(recommendedItinerary);

    await this._modalPopupService.closeAllModals();
    const modalData = await this._modalPopupService.openLeadForm(null, null);
    if (modalData) {
      this._globalService.setRecommendedItinerary(undefined);
    }
  }
}
